'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.138 14.26c-.65-.642-1.462-.642-2.109 0-.493.49-.986.978-1.47 1.475-.133.137-.245.166-.407.075-.319-.174-.659-.315-.965-.506-1.43-.899-2.627-2.055-3.688-3.356-.526-.646-.994-1.338-1.322-2.117-.066-.157-.054-.261.075-.39.493-.476.974-.965 1.458-1.454.676-.68.676-1.475-.004-2.159-.385-.39-.77-.77-1.156-1.16-.398-.398-.791-.8-1.193-1.193-.65-.634-1.463-.634-2.11.004-.496.489-.973.99-1.478 1.471-.469.443-.705.986-.755 1.62-.078 1.032.174 2.006.53 2.954.73 1.964 1.84 3.709 3.187 5.308a19.718 19.718 0 0 0 6.53 5.109c1.144.555 2.33.982 3.618 1.052.886.05 1.657-.174 2.275-.866.422-.472.899-.903 1.346-1.355.663-.67.667-1.483.008-2.146a637.965 637.965 0 0 0-2.37-2.366Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var Phone = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Phone = Phone;